import {
    Paper,
    Box,
    Typography,
    IconButton,
    Grid,
    ThemeProvider,
    useTheme,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow
} from '@mui/material';
import * as React from 'react';
import SimpleCollapse from '../../../component/MuiReusableComponents/MuiCollapse/collapseMUI';
import { useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { Edit } from '@mui/icons-material';
import FormControl from '@mui/material/FormControl';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SearchIcon from '@mui/icons-material/Search';
import { useForm, FormProvider } from 'react-hook-form';
import {
    allInvoicesSelector,
    startInvoicesListDataByPageIndex,
    startSingleInvoice,
    startAddRestoreInvoice,
    startDeleteInvoice,
    startFilterInvoicesListData,
    setRowsPerPage,
    setPage
} from '../../../store1/invoice data/invoiceData.slice.selector';
import { usersDataSelector } from '../../../store1/user login data/user.login.data.slice.slector';
import PrintIcon from '@mui/icons-material/Print';
import MyButton from '../../../component/MuiReusableComponents/MuiButton/buttonMUI';
import MySelect from '../../../component/MuiReusableComponents/MuiFormComponents/Select.component';
import MaterialUIPickers from '../../../component/MuiReusableComponents/MuiFormComponents/DatePicker/date.picker.component';
import { useNavigate, useLocation } from 'react-router-dom';
import FormHead from '../../../component/MuiReusableComponents/FormHeadText/formHeadText';
import PopupDialogs from '../../../component/MuiReusableComponents/MuiPopupDialog/new-popup';
import { useDispatch } from 'react-redux';
import DeletePopup from '../../../component/DeletePopup/deletePopup';
import FilterAndAddBar from '../../../component/ModulesAddAndFilter/moduleAddAndFilter';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { readStringDate } from '../../../function utils/functionUtils';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import {
    FilterDataSelector,
    allClientsDataSelector,
    startAllClientsData,
    startFilterData
} from '../../../store1/client data/client.data.slice.selector';
import InvoiceTable from './customInvoiceTable';
import { hasPermission } from '../../../store1/user login data/user.login.data.slice.slector';
import { PERMISSIONS } from '../../../routes/permissionsCode';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};
/////
const headCells = [
    {
        id: 'id',
        label: 'S No.',
        numeric: false,
        disablePadding: false,
        align: 'left'
    },
    {
        id: 'invoice_number',
        numeric: false,
        disablePadding: false,
        label: 'Invoice Number',
        align: 'left'
    },
    {
        id: 'client_name',
        numeric: false,
        disablePadding: false,
        label: 'Billed to',
        align: 'left'
    },
    {
        id: 'currency_type',
        numeric: false,
        disablePadding: false,
        label: 'Currency Type',
        align: 'left'
    },
    {
        id: 'exchange_rate',
        numeric: false,
        disablePadding: false,
        label: 'Exchange Rate',
        align: 'right'
    },
    {
        id: 'total_amount',
        numeric: false,
        disablePadding: false,
        label: 'Amount',
        align: 'right'
    },

    {
        id: 'added_date',
        numeric: false,
        disablePadding: false,
        label: 'Date of Issued',
        align: 'center'
    },

    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        align: 'left'
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: ' Action',
        align: 'center'
    }
];
const statusArray = [
    { name: 'All', value: 'all invoice' },
    { name: 'Active', value: 1 },
    { name: 'Inactive', value: 0 }
];
////Needed Component
const FilterAndSearchBox = ({ infoData }) => {
    const { setCollapseFilterControl, sortedClientArray, setFilteredRows, rows, setFilterStatus, filterStatus } = infoData; // getting all these props from bottom

    const dispatch = useDispatch();
    React.useEffect(() => {
        if (!filterStatus) {
            form.reset({
                startDateValue: null,
                endDateValue: null,
                personName: 0,
                invoiceStatus: 'all invoice'
            });
        }
    }, [filterStatus]);
    const form = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {
            startDateValue: null,
            endDateValue: null,
            personName: 0,
            invoiceStatus: 'all invoice',
            inv: ''
        }
    });
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const onSubmit = (data) => {
        setIsSubmitting(true);
        let personNameValue = data.personName;
        if (personNameValue === 'All') {
            personNameValue = 0;
        }

        const mappedData = {
            clientName: data.personName,
            invoiceStatus: data.invoiceStatus === 'all invoice' ? -1 : data.invoiceStatus,
            invoiceNumber: data.inv || '',
            startDateValue: data.startDateValue ? formatDate(data.startDateValue) : '',
            endDateValue: data.endDateValue ? formatDate(data.endDateValue) : ''
        };

        dispatch(startFilterInvoicesListData(mappedData));
        dispatch(startFilterData(mappedData));
        setIsSubmitting(false);
    };

    return (
        <Paper sx={{ borderRadius: '10px', marginBottom: '15px', bgcolor: '#dff9fb87' }}>
            <Box
                sx={{
                    textAlign: 'right',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '10px',
                    bgcolor: '#ffeaa786'
                }}
            >
                <Typography
                    sx={{
                        width: '100%',
                        textAlign: 'left',
                        fontWeight: 'bold',

                        paddingLeft: '25px'
                    }}
                    variant="subtitle1"
                    gutterBottom
                >
                    Filter
                </Typography>
            </Box>
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <Grid container columnSpacing={1} sx={{ padding: '10px 20px 0px 20px' }}>
                        <Grid item xs={12} sm={8}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexGrow: '1',
                                    paddingRight: '15px'
                                }}
                            >
                                <FormHead headText="Select Clients" />
                                <FormControl sx={{ width: '100%' }}>
                                    <MySelect
                                        fullWidth
                                        size="small"
                                        name="personName"
                                        style={{ width: '100%' }}
                                        rules={{
                                            required: 'Required !'
                                        }}
                                        defaultItem={{ name: 'All', value: 0 }}
                                        items={[...sortedClientArray]}
                                    />
                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: '0px 15px'
                                }}
                            >
                                <FormHead headText="Invoice Number" />
                                <TextField
                                    size="small"
                                    type="text"
                                    // name="inv"
                                    {...form.register('inv')}
                                    onChange={onchange}
                                    placeholder="Enter Invoice Number"
                                    sx={{
                                        width: '100%'
                                    }}
                                    rules={{
                                        minLength: {
                                            value: 1,
                                            message: 'Minimun length 1'
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: '0px 15px'
                                }}
                            >
                                <FormHead headText="Status " />
                                <MySelect
                                    fullWidth
                                    size="small"
                                    name="invoiceStatus"
                                    style={{ width: '100%' }}
                                    rules={{
                                        required: 'Required !'
                                    }}
                                    items={[...statusArray]}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Grid container rowSpacing={1} columnSpacing={1} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Grid item xs={12} md={7}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <FormHead headText="Date " />
                                        <Box sx={{ display: 'flex' }}>
                                            <MaterialUIPickers
                                                label="Start"
                                                size="small"
                                                views={['year', 'month', 'day']}
                                                name="startDateValue"
                                                placeholder=" Enter Database Column Name"
                                                sx={{
                                                    width: '50%'
                                                }}
                                                rules={{
                                                    required: ' Required',
                                                    minLength: {
                                                        value: 5,
                                                        message: 'Minimun length 5'
                                                    }
                                                }}
                                                maxDate={form.watch('endDateValue')}
                                            />
                                            <Typography variant="body1" sx={{ margin: '0 10px' }}>
                                                to
                                            </Typography>
                                            <MaterialUIPickers
                                                label="End"
                                                size="small"
                                                views={['year', 'month', 'day']}
                                                name="endDateValue"
                                                placeholder=" Enter Database Column Name"
                                                sx={{
                                                    width: '50%'
                                                }}
                                                rules={{
                                                    required: ' Required',
                                                    minLength: {
                                                        value: 5,
                                                        message: 'Minimun length 5'
                                                    }
                                                }}
                                                minDate={form.watch('startDateValue')}
                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    paddingBottom: '10px',
                                    paddingTop: '10px'
                                }}
                            >
                                <MyButton
                                    size="small"
                                    sx={{ marginRight: '15px' }}
                                    variant="contained"
                                    type="submit"
                                    startIcon={<SearchIcon />}
                                    disabled={isSubmitting}
                                >
                                    Search
                                </MyButton>
                                <MyButton
                                    sx={{ marginRight: '15px' }}
                                    onClick={() => {
                                        setFilterStatus(false);
                                        setFilteredRows(rows);
                                        form.reset();

                                        dispatch(
                                            startFilterInvoicesListData({
                                                clientName: 0,
                                                invoiceStatus: 1,
                                                invoiceNumber: '',
                                                startDateValue: '',
                                                endDateValue: '',
                                                pageIndex: 1,
                                                pageSize: 10
                                            })
                                        );

                                        dispatch(setRowsPerPage(10));
                                        dispatch(setPage(1));
                                        // dispatch(startInvoicesListDataByPageIndex());
                                    }}
                                    size="small"
                                    color="error"
                                    variant="contained"
                                >
                                    Reset
                                </MyButton>
                                <MyButton
                                    variant="outlined"
                                    size="small"
                                    onClick={() => setCollapseFilterControl(false)}
                                    startIcon={<CancelPresentationIcon color="error" />}
                                >
                                    Close
                                </MyButton>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </FormProvider>
        </Paper>
    );
};
//Restore Component popup
const InvoiceReasonForm = ({ row, setPopUpBool, pageIndex, pageSize }) => {
    const dispatch = useDispatch();
    const [remarkReason, setRemarkReason] = React.useState('');
    const userLoginData = useSelector(usersDataSelector);
    const fildata = useSelector(FilterDataSelector);

    const reasonChangeHandler = (event) => {
        setRemarkReason(event.target.value);
    };

    const onSubmitHandler = () => {
        if (remarkReason.trim() === '') {
            return;
        }
        setPopUpBool();
        dispatch(
            startAddRestoreInvoice({
                changeRemarkData: {
                    type_id: row?.id,
                    type: 'INVOICE',
                    user_name: userLoginData.userName,
                    user_email: userLoginData.userEmail,
                    remarks: remarkReason,
                    previous_data: JSON.stringify(row)
                },
                tableData: {
                    pageIndex: Number(pageIndex) + 1,
                    pageSize
                },
                filterData: {
                    clientName: fildata.clientName,
                    invoiceStatus: 1,
                    invoiceNumber: fildata.invoiceNumber,
                    startDateValue: fildata.startDateValue,
                    endDateValue: fildata.endDateValue
                },
                updateData: {
                    id: row?.id,
                    invoice_number: row?.invoice_number,
                    client_id: row?.client_id,
                    remarks: row?.remarks,
                    currency_type: row?.currency_type,
                    exchange_rate: row?.exchange_rate,
                    status: 1,
                    finalize: 0,
                    added_by: row?.added_by,
                    url: 'invoice/add'
                }
            })
        );
    };

    return (
        <>
            <Box>
                <Grid container sx={{ p: '10px' }} columnSpacing={1}>
                    <Grid item xs={12}>
                        <TableContainer sx={{ marginBottom: '17px' }}>
                            <Table>
                                <TableBody>
                                    <TableRow
                                        sx={{
                                            borderTop: '2px solid black',
                                            borderLeft: '2px solid black',
                                            borderRight: '2px solid black'
                                        }}
                                    >
                                        <TableCell sx={{ borderRight: '2px solid black', padding: '5px' }}>Current Date:</TableCell>
                                        <TableCell sx={{ padding: '5px' }}>{readStringDate(new Date().toDateString())}</TableCell>
                                    </TableRow>
                                    <TableRow
                                        sx={{
                                            marginBottom: '10px',
                                            border: '2px solid black'
                                        }}
                                    >
                                        <TableCell sx={{ borderRight: '2px solid black', padding: '5px' }}>User Name:</TableCell>
                                        <TableCell sx={{ padding: '5px' }}>{userLoginData.userName}</TableCell>
                                    </TableRow>
                                    <TableRow
                                        sx={{
                                            marginBottom: '10px',
                                            border: '2px solid black'
                                        }}
                                    >
                                        <TableCell sx={{ borderRight: '2px solid black', padding: '5px' }}>User Email:</TableCell>
                                        <TableCell sx={{ padding: '5px' }}>{userLoginData.userEmail}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Divider sx={{ marginY: '20px' }} />

                        <Grid item xs={12} sm={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                                <FormHead
                                    sx={{ whiteSpace: 'nowrap', paddingTop: '15px', color: 'black' }}
                                    headText={`Reason `}
                                    required={true}
                                />

                                <TextField
                                    onChange={reasonChangeHandler}
                                    value={remarkReason}
                                    placeholder="Reason is required"
                                    multiline={true}
                                    rows={3}
                                    fullWidth // Takes full width
                                    sx={{ marginTop: '5px' }} // Adjust top margin as needed
                                    inputProps={{ minLength: 5 }}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Box sx={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                            <MyButton
                                type="submit"
                                startIcon={<WarningAmberIcon color="error" />}
                                size="small"
                                variant="contained"
                                color="success"
                                onClick={onSubmitHandler}
                                sx={{ width: '100%' }}
                                disabled={remarkReason.trim() === '' || remarkReason.length < 5}
                            >
                                Confirm
                            </MyButton>
                            <MyButton
                                type="close"
                                startIcon={<CloseIcon color="error" />}
                                size="small"
                                variant="outlined"
                                color="error"
                                onClick={setPopUpBool}
                                sx={{ width: '100%' }}
                            >
                                Close
                            </MyButton>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};
//Action Column
const ActionColumn = ({ row, pageIndex, pageSize }) => {
    const locationName = useLocation().pathname;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [popUpOpen, setPopUpOpen] = React.useState(false);
    const [popupOpen2, setPopUpOpen2] = React.useState(false);
    const canEditInvoice = useSelector((state) => hasPermission(state, PERMISSIONS.FINANCE.INVOICE.EDIT));
    const canDeleteInvoice = useSelector((state) => hasPermission(state, PERMISSIONS.FINANCE.INVOICE.DELETE));
    const fildata = useSelector(FilterDataSelector);

    function setClosePopup() {
        setPopUpOpen2(false);
        setPopUpOpen(false);
    }
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-evenly'
            }}
        >
            <IconButton
                title="PDF View"
                size="small"
                onClick={() => {
                    dispatch(startSingleInvoice(row.id));
                    navigate(`${locationName}/${row.id}/view-invoice`);
                }}
            >
                <PrintIcon color="primary" />
            </IconButton>

            {!Boolean(row.finalize) && Boolean(row.status) ? (
                <IconButton
                    disabled={!canEditInvoice}
                    title="Edit Invoice"
                    size="small"
                    onClick={() => {
                        dispatch(startSingleInvoice(row.id));
                        navigate(`${locationName}/${row.id}/edit`);
                    }}
                >
                    <Edit color="primary" />
                </IconButton>
            ) : Boolean(row.finalize) && Boolean(row.status) ? (
                <IconButton
                    aria-label="restore"
                    title="Restore Invoice"
                    onClick={() => {
                        setPopUpOpen2(true);
                    }}
                >
                    <SettingsBackupRestoreIcon color="error" />
                </IconButton>
            ) : (
                <IconButton disabled title="Disabled" size="small">
                    <Edit />
                </IconButton>
            )}

            {Boolean(row.status) && !Boolean(row.finalize) ? ( // if row is not there disable delete icon
                <IconButton
                    disabled={!canDeleteInvoice}
                    aria-label="delete"
                    title="Delete Invoice"
                    onClick={() => {
                        setPopUpOpen(true);
                    }}
                >
                    <DeleteIcon color="error" />
                </IconButton>
            ) : (
                <IconButton disabled title="Disabled" size="small">
                    <DeleteIcon />
                </IconButton>
            )}

            <PopupDialogs title={`API`} needTitleBar={false} size="sm" open={popUpOpen} setOpen={setClosePopup}>
                {popUpOpen && (
                    <DeletePopup // its a component in comp folder
                        onClickNo={() => setPopUpOpen(false)}
                        onClickYes={() => {
                            dispatch(
                                startDeleteInvoice({
                                    data: row.id,
                                    tableData: {
                                        pageIndex: Number(pageIndex) + 1,
                                        pageSize
                                    },
                                    filterData: {
                                        clientName: fildata.clientName,
                                        invoiceStatus: 1,
                                        invoiceNumber: fildata.invoiceNumber,
                                        startDateValue: fildata.startDateValue,
                                        endDateValue: fildata.endDateValue
                                    }
                                })
                            );
                        }}
                    />
                )}
            </PopupDialogs>
            <PopupDialogs
                title={`Restore Invoice ${row.invoice_number}`}
                needTitleBar={true}
                size="sm"
                open={popupOpen2}
                setOpen={setClosePopup}
            >
                {popupOpen2 && <InvoiceReasonForm row={row} setPopUpBool={setClosePopup} pageIndex={pageIndex} pageSize={pageSize} />}
            </PopupDialogs>
        </Box>
    );
};
/////////Main Component
const InvoiceData = ({ isLoadingData, pageIndex, pageSize, setPageIndex, setPageSize }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const locationName = useLocation().pathname;
    const allInvoiceData = useSelector(allInvoicesSelector);
    const allClientsData = useSelector(allClientsDataSelector);
    const [data, setData] = React.useState([]);

    const [rowsCount, setRowsCount] = React.useState(0);
    const fildata = useSelector(FilterDataSelector);

    const fecthDataDispatch = () => {
        if (fildata.clientName || fildata.startDateValue || fildata.invoiceNumber || fildata.invoiceStatus) {
            const mapobj = {
                clientName: fildata.clientName,
                invoiceStatus: fildata.invoiceStatus,
                invoiceNumber: fildata.invoiceNumber,
                startDateValue: fildata.startDateValue,
                endDateValue: fildata.endDateValue
            };

            dispatch(startFilterInvoicesListData(mapobj));
        } else {
            dispatch(startInvoicesListDataByPageIndex());
        }
    };

    React.useEffect(() => {
        if (allInvoiceData && allInvoiceData.length > 0) {
            setFilteredRows(allInvoiceData[0]);
            setData(allInvoiceData[0]);
            setRowsCount(allInvoiceData[1][0].total_count);
        }
    }, [allInvoiceData]);
    // React.useEffect(() => {
    //   if (data?.length === 0) {
    //     dispatch(
    //       startInvoicesListDataByPageIndex({
    //         pageSize,
    //         pageIndex: pageIndex + 1,
    //       })
    //     );
    //   }
    // }, [pageIndex, pageSize]);

    React.useEffect(() => {
        dispatch(startAllClientsData());
    }, []);

    const mappedData = {
        clientName: 0,
        invoiceStatus: 1,
        invoiceNumber: '',
        startDateValue: '',
        endDateValue: '',
        pageIndex: 1,
        pageSize: 10
    };

    React.useEffect(() => {
        dispatch(startFilterInvoicesListData(mappedData));
    }, []);

    const [collapseFilterControl, setCollapseFilterControl] = React.useState(false);
    const [filterStatus, setFilterStatus] = React.useState(false);
    const [filteredRows, setFilteredRows] = React.useState([]);
    const statusFilertClientArray = allClientsData.filter((item) => Boolean(item.status));

    const selectClientArray = statusFilertClientArray.map((item) => {
        return {
            name: item.name,
            value: item.id
        };
    });
    const sortedClientArray = [...selectClientArray];

    sortedClientArray.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        return 0;
    });

    React.useEffect(() => {
        setFilteredRows(allInvoiceData);
    }, [allInvoiceData]);
    const theme = useTheme();
    const canCreateInvoice = useSelector((state) => hasPermission(state, PERMISSIONS.FINANCE.INVOICE.CREATE));
    const onclickFilter = () => setCollapseFilterControl(!collapseFilterControl);
    const onClickAdd = () => navigate('/manage-accounts/invoice-management/invoice-list/add-invoice');

    return (
        <ThemeProvider theme={theme}>
            <Box>
                <FilterAndAddBar
                    onclickFilter={onclickFilter}
                    onClickAdd={onClickAdd}
                    filterStatus={filterStatus}
                    setCollapseFilterControl={setCollapseFilterControl}
                    collapseFilterControl={collapseFilterControl}
                    filterName=" Filter"
                    AddButtonName=" + Create New Invoice"
                    showAddButton={canCreateInvoice}
                />

                <SimpleCollapse
                    infoData={{
                        setCollapseFilterControl,
                        sortedClientArray,
                        setFilteredRows,
                        setFilterStatus,
                        filterStatus,
                        rows: allInvoiceData
                    }}
                    control={collapseFilterControl}
                    CollapseComponent={FilterAndSearchBox}
                />
                <Box>
                    <InvoiceTable
                        headCells={headCells}
                        isLoading={isLoadingData}
                        loadingMessage={'Loading Please wait'}
                        ActionComponent={ActionColumn}
                        data={data}
                        dispatchAPI={fecthDataDispatch}
                        rowsCount={rowsCount}
                        setRowsCount={setRowsCount}
                        pathName={locationName}
                        pageSize={pageSize}
                        pageIndex={pageIndex}
                        setPageSize={setPageSize}
                        setPageIndex={setPageIndex}
                    />
                </Box>
            </Box>
        </ThemeProvider>
    );
};
export default InvoiceData;
